import Icon, { BaseProps } from "../Icon/Icon";
import React from "react";

type CreateIconProps = {
  path: React.ReactElement;
};

function createIcon({ path }: CreateIconProps) {
  return (props: BaseProps) => <Icon {...props}>{path}</Icon>;
}

export default createIcon;
